// == Pack: active_admin.js
// Shakapacker entry point for the ActiveAdmin backend.

// Restore jQuery 3.x APIs removed in jQuery 4.0.0 (isArray, isFunction, etc.)
// before any package that depends on them is loaded.
import "./jquery_compat"

// Load images into the webpack graph
const imageContext = require.context("../images", true)
imageContext.keys().forEach(imageContext)

import "../stylesheets/active_admin.scss"

// jQuery UI widgets must be explicitly bundled by webpack before @activeadmin/activeadmin
// loads. active_admin/base.js is a pre-compiled UMD; webpack processes it as AMD and does
// not statically follow the require("jquery-ui/...") calls inside it.
import "jquery-ui/ui/widget"
import "jquery-ui/ui/widgets/datepicker"
import "jquery-ui/ui/widgets/dialog"
import "jquery-ui/ui/widgets/draggable"
import "jquery-ui/ui/widgets/resizable"
import "jquery-ui/ui/widgets/sortable"
import "jquery-ui/ui/widgets/tabs"

import "@activeadmin/activeadmin"
import "activeadmin_addons"
import "@activeadmin-plugins/active_admin_datetimepicker"
import "active_material"
import "@claviska/jquery-minicolors/jquery.minicolors"
import "@claviska/jquery-minicolors/jquery.minicolors.css"

import "@fontsource/montserrat/400.css"
import "@fontsource/montserrat/500.css"
import "@fontsource/montserrat/700.css"
import "@fortawesome/fontawesome-free/css/all.css"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import "controllers"

import JSONEditor from "jsoneditor"
import "jsoneditor/dist/jsoneditor.css"
import "jsoneditor/dist/img/jsoneditor-icons.svg"

import { Chart } from "chart.js"
import annotationPlugin from "chartjs-plugin-annotation"
Chart.register(annotationPlugin)
import "chartkick/chart.js"

import DataTable from "datatables.net"

import ace from "ace-builds"
import "ace-builds/src-noconflict/mode-javascript"
import "ace-builds/src-noconflict/mode-css"
import "ace-builds/src-noconflict/theme-xcode"
ace.config.set("useWorker", false)

import '../wyswyg_editor'

import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false

// Custom Turbo 8 stream actions used by ProcessSitemapJob / ReindexSitemapJob.
// Turbo 7 used the turbo:before-stream-render override pattern; Turbo 8 requires StreamActions.

// Fired by on_complete: hides the processing indicator or removes the completed job row.
Turbo.StreamActions.finish = function() {
  const targetId = this.target
  if ($("body").hasClass("edit") && $("body").hasClass("admin_knowledge_repositories")) {
    $(`#${targetId}`).hide()
    $.post("sitemap_stat", {
      sitemap: targetId.replace(/[^\d.]/g, ""),
    }).done(data => {
      $(`#${targetId}`).parent("li").prev("li").find("p.inline-hints").html(data)
    })
  } else if ($("body").hasClass("admin_good_job_jobs")) {
    $(`#${targetId}`).closest("tr").remove()
  } else {
    $(`#${targetId}`).hide()
  }
}

// Fired by after_enqueue: reloads the Background Jobs index so the new row appears.
Turbo.StreamActions.reload_jobs = function() {
  if ($("body").hasClass("admin_good_job_jobs")) {
    clearTimeout(window._reloadJobsTimer)
    window._reloadJobsTimer = setTimeout(() => window.location.reload(), 300)
  }
}

// Fired by AsSeenByAIReportRun on every change: re-fetches the report status/history block.
Turbo.StreamActions.refresh_as_seen_by_ai_reports = function() {
  // The status block now tells the progress; drop the "Report queued" note.
  $("#as_seen_by_ai_message").removeClass("error").text("")
  reloadAsSeenByAIReports()
}

// jQuery is injected globally via ProvidePlugin in webpack config.
// Make it explicit on window for plugins that probe window.jQuery.
window.$ = window.jQuery = jQuery
import "jquery-ujs"

// ── JSONEditor init ──────────────────────────────────────────────────────────

const initEditor = (_i, wrap) => {
  const fieldset = $(wrap).parents("li:eq(0)")
  const container = $(wrap)[0]
  const textarea = $($(wrap).find("textarea"))
  let editor

  const options = {
    modes: ["tree", "text"],
    mode: "tree",
    change() {
      try {
        const text = JSON.stringify(editor.get())
        textarea.text(text)
        fieldset.toggleClass("error", false)
      } catch (e) {
        options.error(e)
      }
    },
    error() {
      fieldset.toggleClass("error", true)
    },
  }

  textarea.hide()
  editor = new JSONEditor(container, options, JSON.parse(textarea.val()))
}

// ── Global helpers (called from AA view onclick attributes) ──────────────────

window.inspect_url = function(el) {
  window.loader = $("#dialog-loader").dialog({ dialogClass: "no-close", modal: true })
  const dialog = $("#inspect-url").dialog({
    autoOpen: false, height: 640, width: 800, modal: true,
    buttons: { Ok() { dialog.dialog("close") } },
  })
  window.inspect_url_dialog = dialog
  const sitemap = $(el).parents("fieldset.has_many_fields")
  $.post("inspect_url", {
    url: sitemap.find("input[type='url']").val(),
    driver: sitemap.find("select").val(),
    sitemap: sitemap.find("input[type='hidden']").val(),
    styles: sitemap.find("textarea").eq(0).val(),
  }).done(data => {
    window.loader.dialog("close")
    setTimeout(() => {
      $("#inspect-url-content").html(data)
      dialog.dialog("option", "title", $("#inspect-url-content").find("h3").text())
      $("#inspect-url-content").find("h3").hide()
      setTimeout(() => {
        $(".ui-widget-overlay").css({ opacity: "0.75", height: `${$(document).height()}px` })
      }, 50)
      dialog.dialog("open")
    }, 100)
  })
}

window.test_action = function(el) {
  window.loader = $("#dialog-loader").dialog({ dialogClass: "no-close", modal: true })
  const dialog = $("#inspect-url").dialog({
    autoOpen: false, height: 640, width: 800, modal: true,
    buttons: { Ok() { dialog.dialog("close") } },
  })
  window.inspect_url_dialog = dialog
  const action = $(el).parents("fieldset.has_many_fields")
  $.post("test_action", {
    url: action.find("input[type='url']").val(),
    code: ace.edit(action.find("div[class~='ace-editor-container']").attr("id")).getValue(),
    template: action.find("textarea[name*='template']").val(),
    aid: action.find("input[type='hidden']").val(),
  }).done(data => {
    window.loader.dialog("close")
    setTimeout(() => {
      $("#inspect-url-content").html(data)
      dialog.dialog("option", "title", $("#inspect-url-content").find("h3").text())
      $("#inspect-url-content").find("h3").hide()
      setTimeout(() => {
        $(".ui-widget-overlay").css({ opacity: "0.75", height: `${$(document).height()}px` })
      }, 50)
      dialog.dialog("open")
    }, 100)
  })
}

window.process_url = function(el) {
  window.loader = $("#dialog-loader").dialog({ dialogClass: "no-close", modal: true })
  $(el).hide()
  const sitemap = $(el).parents("fieldset.has_many_fields")
  const sitemapId = sitemap.find("input[type='hidden']").val()
  $(`#sitemap_${sitemapId}_process`).show()
  $.post("process_now", { sitemap: sitemapId }).done(() => {
    window.loader.dialog("close")
    setTimeout(() => alert("Process is scheduled. It will be done asynchronously."), 100)
    $.post("sitemap_stat", { sitemap: sitemapId }).done(data => {
      sitemap.find("li:nth-child(2) p.inline-hints").html(data)
    })
  })
}

window.process_action = function(el) {
  window.loader = $("#dialog-loader").dialog({ dialogClass: "no-close", modal: true })
  $(el).hide()
  const action = $(el).parents("fieldset.has_many_fields")
  $.post("generate_action", { aid: action.find("input[type='hidden']").val() }).done(() => {
    window.loader.dialog("close")
    setTimeout(() => alert("Process is scheduled. It will be done asynchronously."), 100)
  })
}

// ── jQuery document-ready ────────────────────────────────────────────────────

$(function() {
  $("div.jsoneditor-wrap").each(initEditor)

  $(document).on("has_many_add:after", ".has_many_container", (_e, fieldset) => {
    $("div.jsoneditor-wrap", fieldset).each(initEditor)
  })

  // Prevent Slim Select from hijacking batch action dialog selects.
  // ModalDialog appends the form to <body> then fires this event synchronously,
  // before the MutationObserver microtask runs — so stamping .default-select here
  // causes Slim Select's `select:not(.default-select)` selector to skip them.
  $("body").on("modal_dialog:before_open", (_event, form) => {
    form.find("select").addClass("default-select")
  })
})

// ── DOMContentLoaded ─────────────────────────────────────────────────────────

function openDownloadLinksInNewTab() {
  document.querySelectorAll(".download_links a").forEach(a => {
    a.target = "_blank"
    a.rel = "noopener noreferrer"
  })
}
document.addEventListener("turbo:load", openDownloadLinksInNewTab)

document.addEventListener("DOMContentLoaded", () => {
  openDownloadLinksInNewTab
  let contrastGlobalCloserBound = false

  // Right filter sidebar
  const sidebar = document.querySelector("#settings")
  if (sidebar) {
    sidebar.addEventListener("click", event => {
      const insideSection = document.querySelector("#settings_section")
      if (!(event.target === insideSection || insideSection.contains(event.target))) {
        sidebar.classList.toggle("settings_open")
      }
    })
  }

  const menuButton = document.querySelector("#site_title")
  const menu = document.querySelector("#tabs")

  menuButton?.addEventListener("click", event => {
    const logo = document.querySelector("#site_title_image")
    if (!logo) return
    if (!(event.target === logo || logo.contains(event.target))) {
      menu?.classList.toggle("tabs_open")
    }
  })

  document.body.addEventListener("click", event => {
    if (!sidebar) return
    const forbidden = event.target === sidebar || sidebar.contains(event.target)
    if (sidebar.classList.contains("settings_open") && !forbidden) {
      sidebar.classList.remove("settings_open")
    }
  })

  var initialProjectType = $("input[name='project[project_type]']:checked").val();
  if (initialProjectType === 'GRA') {
    $('#gra_wyswyg').wysywgEditor({ config: 'admin-gra' });
  } else if (initialProjectType === 'Assistant') {
    $('#assistant_wyswyg').wysywgEditor({ config: 'admin-assistant' });
  }

  function getCurrentProjectType() {
    return $("input[name='project[project_type]']:checked").val()
  }

  const HEX_COLOR_RE = /^#?[0-9a-f]{6}$/i

  // Some project_*_color fields default to a non-hex value ("", "unset", null) and only get a
  // real color from the widget once another field is blank too, or from a value hardcoded in
  // the widget itself — reading the raw field value in that case gives NaN and the pair silently
  // "passes". These are the effective colors the real widgets render for such defaults, verified
  // against their actual sources (not the wyswyg preview mockup's own CSS, which doesn't always
  // match): Assistant -> ../know-it-all/src/Assistant.js, GRA -> ../gra-toolkit/src/Assistant.js.
  // A string value here is another project_*_color field id to resolve recursively; a "#..."
  // value is the widget's own hardcoded terminal default.
  const EFFECTIVE_COLOR_FALLBACKS = {
    GRA: {
      project_chat_question_title_color: "#011839",
      project_chat_answer_title_color: "#011839",
      project_chat_question_subtitle_color: "#6D787E",
      project_chat_answer_subtitle_color: "#6D787E",
      project_chat_question_text_color: "#011839",
      project_chat_answer_text_color: "#011839",
      project_question_answer_title_color: "#011839",
      project_question_answer_textcolor: "#011839",
    },
    Assistant: {
      project_chat_question_title_color: "project_question_answer_title_color",
      project_chat_answer_title_color: "project_question_answer_title_color",
      project_chat_question_subtitle_color: "project_question_answer_subtitle_color",
      project_chat_answer_subtitle_color: "project_question_answer_subtitle_color",
      project_chat_question_text_color: "project_question_answer_textcolor",
      project_chat_answer_text_color: "project_question_answer_textcolor",
      project_question_answer_title_color: "#011839",
      project_question_answer_textcolor: "#011839",
      project_terms_conditions_background_color: "project_background_color",
    },
  }

  // Resolves the color a field actually renders as, following the same "blank falls back to
  // another field" chain the real widget uses — instead of the raw (possibly blank/non-hex)
  // stored value. `sourceId` is the field whose own value the color actually came from: `id`
  // itself when its raw value is valid (or its blank value maps straight to a hardcoded widget
  // default, with no other field involved), or the field further down the chain that supplied
  // the color otherwise. Returns { color: null, sourceId: null } when nothing resolves.
  function resolveColor(id, seen = new Set()) {
    if (seen.has(id)) return { color: null, sourceId: null }
    seen.add(id)
    const raw = ($(".minicolors-input").filter(`#${id}`).val() || "").trim()
    if (HEX_COLOR_RE.test(raw)) return { color: raw, sourceId: id }
    const fallback = (EFFECTIVE_COLOR_FALLBACKS[getCurrentProjectType()] || {})[id]
    if (!fallback) return { color: null, sourceId: null }
    if (HEX_COLOR_RE.test(fallback)) return { color: fallback, sourceId: id }
    return resolveColor(fallback, seen)
  }

  const FALLBACK_DEPENDENTS = {}
  Object.keys(EFFECTIVE_COLOR_FALLBACKS).forEach(type => {
    FALLBACK_DEPENDENTS[type] = {}
    Object.keys(EFFECTIVE_COLOR_FALLBACKS[type]).forEach(fieldId => {
      const fallback = EFFECTIVE_COLOR_FALLBACKS[type][fieldId]
      if (HEX_COLOR_RE.test(fallback)) return
      if (!FALLBACK_DEPENDENTS[type][fallback]) FALLBACK_DEPENDENTS[type][fallback] = []
      FALLBACK_DEPENDENTS[type][fallback].push(fieldId)
    })
  })

  $(".minicolors-input").each(function() {
    const item = $(this)
    contrastMessage(item)
    const options = $.extend({}, item.data("minicolors"))
    item.data("minicolors", null)
    item.minicolors(options)
  })

  // ── Model select: conditional field visibility ───────────────────────────

  const CAPABILITY_MODELS = [
    "gpt-4o", "gpt-4o-mini", "gpt-4o-2024-05-13", "gpt-4o-2024-08-06",
    "gpt-4o-audio-preview", "gpt-4.1", "gpt-4.1-mini", "gpt-4.1-nano",
    "gpt-5", "gpt-5-mini", "gpt-5-nano",
    "mistral-small-latest", "mistral-large-latest",
    "claude-sonnet-4-6", "claude-opus-4-6", "claude-opus-4-8",
    "claude-haiku-4-5-20251001", "gemini-2.5-flash",
  ]

  $("#project_model").change(function() {
    const val = $(this).val()
    const featureInputs = $("#project_use_gpt_function,#project_pass_history,#project_filter_by_request_date")
    if (CAPABILITY_MODELS.includes(val)) {
      featureInputs.removeAttr("disabled")
    } else {
      featureInputs.prop("checked", false).attr("disabled", "disabled")
    }
    if (/^(mistral|claude)/.test(val)) {
      const temp = $("#project_temperature")
      if (parseInt(temp.val()) > 1) temp.val(Math.floor(parseInt(temp.val()) / 2))
      temp.attr("max", 1)[0].dispatchEvent(new Event("input"))
      $("#project_openai_key").parent("li").hide()
    } else {
      $("#project_openai_key").parent("li").show()
      $("#project_temperature").attr("max", 2)
    }
  }).change()

  $("#project_use_gpt_function").change(function() {
    if (this.checked) {
      $("#project_ctx_llm_method").attr("disabled", "disabled")
    } else {
      $("#project_ctx_llm_method").removeAttr("disabled")
    }
  })

  $("#project_pii_enabled").change(function() {
    const piiCheckboxes = $("input[name='project[pii_entities][]']")
    if (!this.checked) {
      piiCheckboxes.prop("checked", false).attr("disabled", "disabled")
    } else {
      $("#project_pii_entities_credit_card,#project_pii_entities_email_address,#project_pii_entities_phone_number,#project_pii_entities_us_driver_license,#project_pii_entities_crypto,#project_pii_entities_uk_nhs,#project_pii_entities_us_bank_number,#project_pii_entities_us_itin,#project_pii_entities_us_passport,#project_pii_entities_us_ssn").prop("checked", true)
      piiCheckboxes.removeAttr("disabled")
    }
  })

  $("input[name='project[splitter_mode]']").change(function() {
    const isSemantic = $("input[name='project[splitter_mode]']:checked").val() === "semantic"
    $("#project_chunk_size_input,#project_chunk_overlap_input").toggle(!isSemantic)
  }).change()

  $("input[name*='project[urls_attributes]']").filter("input[type='url']").attr("disabled", "disabled")
  $("input[name*='project[sitemaps_attributes]']").filter("input[type='url']").attr("disabled", "disabled")

  $("body.edit.admin_projects ul.nav-tabs li a").click(function() {
    $("#project_tab").val($(this).attr("href"))
    const sidebar = $("#sidebar")
    if (sidebar.length) {
      sidebar.toggle(["#branding", "#widget-settings"].includes($(this).attr("href")))
    }
  })

  $("body.edit.admin_knowledge_repositories ul.nav-tabs li a").click(function() {
    $("#knowledge_repository_tab").val($(this).attr("href"))
    if ($(this).attr("href") === "#properties") {
      $("#redo, #reindex").show()
    } else {
      $("#redo, #reindex").hide()
    }
  })

  if ($("body.edit.admin_projects").length === 1) {
    const tab = new URLSearchParams(window.location.search).get("tab")
    setTimeout(() => {
      $(`body.edit.admin_projects div.tabs li a[href='${decodeURI(tab)}']`).click()
    }, 100)
  }

  if ($("body.edit.admin_knowledge_repositories").length === 1) {
    const tab = new URLSearchParams(window.location.search).get("tab")
    setTimeout(() => {
      $(`body.edit.admin_knowledge_repositories div.tabs li a[href='${decodeURI(tab)}']`).click()
    }, 100)
  }

  if ($("body.edit.admin_clients").length === 1) {
    const tab = new URLSearchParams(window.location.search).get("tab")
    setTimeout(() => {
      $(`body.edit.admin_clients div.tabs li a[href='${decodeURI(tab)}']`).click()
    }, 100)
  }

  $("#project_enable_events").change(function() {
    $("#project_default_location_input").toggle(this.checked)
    $("#project_categorize_events_input").toggle(this.checked)
  }).change()

  $("#project_enable_nearest_objects").change(function() {
    $("#project_default_locality").parent("li").toggle(this.checked)
  }).change()

  $("#project_enable_local_businesses").change(function() {
    $("#project_randomize_objects_input,#project_consider_featured_objects_input").toggle(this.checked)
  }).change()

  $(".clear_filters_btn").click(function() {
    document.location.href = `${$(this).parents("form").attr("action")}?commit=clear_filters`
    return false
  })

  $("#knowledge_repository_languages").on("change", function() {
    const langs = $(this).val()
    const hybridInputs = $("input[name='knowledge_repository[hybrid_search]']")
    if (langs?.length > 0) {
      const supported = $("#knowledge_repository_hybrid_search_true").data("langs")
      if (supported?.includes(langs[0].toLowerCase())) {
        hybridInputs.removeAttr("disabled")
      } else {
        $("#knowledge_repository_hybrid_search_false").prop("checked", true)
        hybridInputs.attr("disabled", true)
      }
    } else {
      $("#knowledge_repository_hybrid_search_false").prop("checked", true)
      hybridInputs.attr("disabled", true)
    }
  })

  $("input[name='project[ia_cap_type]']").change(function() {
    const isRecurring = ["annual", "monthly"].includes($("input[name='project[ia_cap_type]']:checked").val())
    $("#project_finishing_on").parent("li").toggle(!isRecurring)
  }).change()

  // ── Project type switcher ────────────────────────────────────────────────

  const ASSISTANT_SETTINGS = [
    "widget_position", "header_text", "header_color", "header_text_color",
    "border_color", "background_color", "question_answer_title_color",
    "question_answer_subtitle_color", "question_answer_textcolor",
    "icon_chat_text_color", "icon_chat_background_color_from",
    "icon_chat_background_color_to", "icon_chat_hover_background_color",
    "icon_chat_hover_text_color", "icon_close_text_color",
    "icon_close_background_color_from", "icon_close_background_color_to",
    "icon_close_hover_background_color", "icon_close_hover_text_color",
    "start_chat_icon_source", "running_chat_icon_source",
    "fullscreen_title_icon_source", "icon_hello_color", "hello_text_color",
    "icon_main_window_close_color",
    "icon_resize_color", "icon_thumb_border_color", "icon_thumb_background_color",
    "welcome_message_title", "welcome_message_subtitle", "hint_message",
    "feedback", "resize", "hint_text_color", "hint_border_color",
    "hint_background_color", "open_maximized", "text_icon_length",
    "text_icon_font_size", "text_icon_close_font_size", "text_icon_text",
    "text_icon_close_text", "hint_position", "mobile_horisontal_margin",
    "text_icon_mobile_length", "text_icon_mobile_text",
    "icon_vertical_offset", "icon_horizontal_offset", "feedback_true",
    "resize_true", "hint_window_width", "hint_font_size", "open_maximized_true",
    "theme_switch_true", "icon_dark_mode_color", "icon_light_mode_color",
    "font_size_switch_true", "icon_font_size_change_color","limit_text_color",
    "icons_chat_close_border_color", "demo_background", "terms_conditions_link_color",
    "terms_conditions_background_color",
  ]

  const GRA_SETTINGS = [
    "form_block_top_text", "form_input_type", "banner_background_color",
    "icon_input_question_scale", "icon_input_question", "icon_send",
    "icon_send_scale", "icon_send_hover", "icon_send_hover_scale",
    "question_icon", "icon_answer_scale", "icon_question_scale",
    "answer_question_block_inside_padding", "answer_question_block_width",
    "answer_question_block_border_radius", "answer_block_border_radius_bottom_right",
    "answer_block_border_radius_bottom_left", "question_block_border_radius_bottom_right",
    "question_block_border_radius_bottom_left", "icon_question_no_display",
    "icon_input_question_no_display", "icon_answer_no_display",
    "input_border_radius", "input_height", "banner_restart_timeout",
    "chat_activation_event", "banner_container_id", "typing_dots_size",
    "typing_dots_margin_between", "typing_dots_jump_height", "form_block_position",
    "input_border_width", "input_border_color", "icon_scroll_down_background_color",
    "base_font_size_input_field", "hide_answer_block_before_answer",
    "answer_top_position", "first_message_title", "first_message_subtitle",
    "chat_block_scrollbar_width", "terms_conditions_link_color",
  ]

  const refreshColorGroupVisibility = () => {
    $(".color-group, .color-subgroup, .color-subgroup-box").each(function () {
      const $container = $(this)
      const hasVisibleField = $container.find("li.input").toArray().some(li => $(li).css("display") !== "none")
      $container.toggle(hasVisibleField)
    })
  }

  const moveAnswerIcon = (beforeId) => {
    const $li = $("#project_answer_icon_input")
    const $next = $li.next()
    const $img = $next.is("img") ? $next : null
    $li.insertBefore($(`#${beforeId}`))
    if ($img) $img.insertAfter($li)
  }

  $("input[name='project[gibberish]'], input[name='project[toxicity]'], input[name='project[prompt_injection]'], input[name='project[banned_topics]']").change(function () {
    var state = $("input[name='" + $(this).attr("name") + "']:checked").val();
    var property = $(this).attr("name").match(/\[([^\]]+)\]/)[1];
    var show = state == 'true';
    if (property === 'gibberish') {
      $("input[name='project[word_salad_threshold]']").parents("li").toggle(show)
      $("input[name='project[mild_gibberish_threshold]']").parents("li").toggle(show)
    } else {
      $("input[name='project[" + property + "_threshold]']").parents("li").toggle(show)
      $("input[name='project[" + property + "_categories][]']").parents("li").toggle(show)
    }
  }).change();

  $("input[name='project[project_type]']").change(function() {
    const selectedType = $("input[name='project[project_type]']:checked").val()

    if ($("body").hasClass("new")) {
      const defaults = ($("form").data("type-defaults") || {})[selectedType] || {}
      Object.keys(defaults).forEach(key => $(`#project_${key}`).val(defaults[key]))
    }

    switch (selectedType) {
      case "GRA":
        $("#project_utm_label").parent("li").show()
        $("#ui-id-3").parent().show()
        $("#ui-id-8").parent().show()
        $('div[aria-labelledby="ui-id-2"]>fieldset:nth-child(1)>ol>li').show()
        $('div[aria-labelledby="ui-id-2"]>fieldset').show()
        $("#gra-custom,#gra-dates").show()
        $("#project_ia_cap_type_input,#project_starting_on_input,#project_finishing_on_input").hide()
        $("#icon-pos-tweaks,#mobile-tweaks,#hint,#only-text-app-icon").hide()
        $("#project_first_message_text").parents("li").find(".inline-hints").show()
        $("#gra_wyswyg").show()
        $("#assistant_wyswyg").hide()
        if (initialProjectType !== 'GRA') {
          if (!$('#gra_wyswyg').find('.wyswyg-save-notice').length) {
            $('#gra_wyswyg').html('<div class="wyswyg-save-notice">Save the project to activate the editor for GRA type</div>');
          }
        }
        ;["#project_greeting", "#project_farewell", "#project_gratitude", "#project_subscribe"].forEach(id => {
          $(id).parent("li").show()
        })
        ASSISTANT_SETTINGS.forEach(k => $(`#project_${k}`).parents("li").hide())
        GRA_SETTINGS.forEach(k => $(`#project_${k}`).parents("li").show())
        $(".color-custom-setting-link.assistant-only").hide()
        $(".color-custom-setting-link.gra-only").show()
        refreshColorGroupVisibility()
        $("#alternative-icons,#demo-section").hide()
        moveAnswerIcon("project_icon_answer_scale_input")
        $("#project_custom_js_input .inline-hints").text("Without HTML opening/closing tags. Use pattern global['Setting_name' + index] to set GRA settings. Example: global['Intf_FirstMessageTitle' + index]")
        $("#project_custom_style_input .inline-hints").text("Without HTML opening/closing tags. To override the chat classes, you need to add '_custom' to the end of the class name. Example: '.chat_container_intf' → '.chat_container_intf_custom'.")
        break

      case "Assistant":
        $("#project_utm_label").parents("li").hide()
        $("#ui-id-3").parent().show()
        $("#ui-id-8").parent().show()
        $('div[aria-labelledby="ui-id-2"]>fieldset:nth-child(1)>ol>li').show()
        $('div[aria-labelledby="ui-id-2"]>fieldset').show()
        $("#gra-custom,#gra-dates").hide()
        $("#project_ia_cap_type_input,#project_starting_on_input,#project_finishing_on_input").show()
        $("#icon-pos-tweaks,#mobile-tweaks,#hint,#only-text-app-icon").show()
        $("#project_first_message_text").parents("li").find(".inline-hints").hide()
        $("#gra_wyswyg").hide()
        $("#assistant_wyswyg").show()
        if (initialProjectType !== 'Assistant') {
          if (!$('#assistant_wyswyg').find('.wyswyg-save-notice').length) {
            $('#assistant_wyswyg').html('<div class="wyswyg-save-notice">Save the project to activate the editor for Assistant type</div>');
          }
        }
        ;["#project_greeting", "#project_farewell", "#project_gratitude", "#project_subscribe"].forEach(id => {
          $(id).parent("li").show()
        })
        GRA_SETTINGS.forEach(k => $(`#project_${k}`).parents("li").hide())
        ASSISTANT_SETTINGS.forEach(k => $(`#project_${k}`).parents("li").show())
        $(".color-custom-setting-link.gra-only").hide()
        $(".color-custom-setting-link.assistant-only").show()
        refreshColorGroupVisibility()
        $("#alternative-icons,#demo-section").show()
        moveAnswerIcon("project_fullscreen_title_icon_input")
        $("#project_custom_js_input .inline-hints").text("Without HTML opening/closing tags. Use pattern global.'Setting_name' to set Assistant settings. Example: global.Intf_inputLimitm = 50")
        $("#project_custom_style_input .inline-hints").text("Without HTML opening/closing tags")
        break
      default:
        $("#project_utm_label").parent("li").hide()
        $("#ui-id-3").parent().hide()
        $("#ui-id-8").parent().hide()
        $('div[aria-labelledby="ui-id-2"]>fieldset:not(:nth-child(1))').hide()
        $('div[aria-labelledby="ui-id-2"]>fieldset:nth-child(1)>ol>li').hide()
        $("#project_include_links").parents("li").show()
        $("#gra-dates").hide()
        $("#project_ia_cap_type_input,#project_starting_on_input,#project_finishing_on_input").show()
        ;["#project_greeting", "#project_farewell", "#project_gratitude", "#project_subscribe"].forEach(id => {
          $(id).parent("li").hide()
        })
        moveAnswerIcon("project_fullscreen_title_icon_input")
        $("#project_custom_js_input .inline-hints").text("Without HTML opening/closing tags. Use 'global' to set widget settings instead of 'window'")
        $("#project_custom_style_input .inline-hints").text("Without HTML opening/closing tags")
    }

    $(".minicolors-input").trigger("contrastUpdate")
  }).change()

  setTimeout(() => $("input[name='project[project_type]']").change(), 100)

  $("#project_active").change(function () {
    const $labels = $("#project_campaign_start_date_input label, #project_campaign_end_date_input label")
    $labels.find("abbr[title='required']").remove()
    if (this.checked) $labels.append('<abbr title="required">*</abbr>')
  })

  if(($("body").hasClass("edit") || $("body").hasClass("new")) && $("body").hasClass("admin_projects")){
    var initialTab = $("#project_tab").val();
    if(['#branding', '#widget-settings'].includes(initialTab)){
      $("#sidebar").show();
    } else {
      $("#sidebar").hide();
    }
  }

  // ── DataTables: logs ─────────────────────────────────────────────────────

  const params = new URLSearchParams(window.location.search)
  // Merge form values: session-restored filters aren't in window.location.search
  const filterForm = document.querySelector("body.index.admin_logs .filter_form")
  if (filterForm) {
    new URLSearchParams(new FormData(filterForm)).forEach((value, key) => {
      if (value) params.set(key, value)
    })
  }
  params.delete("order")

  $("body.index.admin_logs #index_table_logs tbody").empty()

  const table = new DataTable("body.index.admin_logs .index_table", {
    ajax: {
      type: "POST",
      url: `/admin/logs/data?${params.toString()}`,
      data: { authenticity_token: $('meta[name="csrf-token"]').attr("content") },
    },
    processing: true,
    serverSide: true,
    searching: false,
    ordering: true,
    lengthChange: false,
    language: { info: "Displaying Logs _START_ - _END_ of _TOTAL_ in total" },
    columns: [
      { className: "dt-control", orderable: false, searchable: false, data: null, defaultContent: "" },
      { data: "created_at" },
      { data: "project", orderable: false },
      { data: "chat" },
      { data: "question" },
      { data: "fc", orderable: false },
      { data: "production", orderable: false },
      { data: "spam", orderable: false },
      { data: "tokens" },
      { data: "comments", orderable: false, searchable: false },
    ],
    order: [[1, "desc"]],
  })

  const fetchRowDetails = rowData => {
    const div = $("<div/>").addClass("loading").text("Loading...")
    $.ajax({
      type: "POST",
      url: `/admin/logs/${rowData.DT_RowId}/details/`,
      dataType: "json",
      data: { authenticity_token: $('meta[name="csrf-token"]').attr("content") },
      success(json) { div.html(json.html).removeClass("loading") },
    })
    return div
  }

  $("#index_table_logs tbody").on("click", "td.dt-control", function() {
    const tr = $(this).closest("tr")
    const row = table.row(tr)

    $(".dt-hasChild.shown").each(function() {
      const row2 = table.row($(this).closest("tr").next())
      if (row2.child.isShown() && row2.data().DT_RowId !== row.data().DT_RowId) {
        row2.child.hide()
        tr.removeClass("shown")
      }
    })

    if (row.child.isShown()) {
      row.child.hide()
      tr.removeClass("shown")
    } else {
      row.child(fetchRowDetails(row.data())).show()
      tr.addClass("shown")
    }
  })

  // ── Contrast checker ─────────────────────────────────────────────────────


  function getLuminance(hex) {
    hex = hex.replace("#", "")
    const [r, g, b] = [
      parseInt(hex.substring(0, 2), 16) / 255,
      parseInt(hex.substring(2, 4), 16) / 255,
      parseInt(hex.substring(4, 6), 16) / 255,
    ].map(c => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)))
    return 0.2126 * r + 0.7152 * g + 0.0722 * b
  }

  function getContrastRatio(hex1, hex2) {
    const L1 = getLuminance(hex1)
    const L2 = getLuminance(hex2)
    return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05)
  }

  function contrastMessage(item) {
    const colorPars = {
      project_answer_background_color: [
        { pareKey: "project_icon_copy_button_color", rateValue: 3 },
        { pareKey: "project_question_answer_title_color", rateValue: 4.5 },
        { pareKey: "project_question_answer_subtitle_color", rateValue: 4.5 },
        { pareKey: "project_question_answer_textcolor", rateValue: 4.5 },
        { pareKey: "project_chat_answer_title_color", rateValue: 4.5 },
        { pareKey: "project_chat_answer_subtitle_color", rateValue: 4.5 },
        { pareKey: "project_chat_answer_text_color", rateValue: 4.5 },
      ],
      project_chat_answer_title_color:    [{ pareKey: "project_answer_background_color", rateValue: 4.5 }],
      project_chat_answer_subtitle_color: [{ pareKey: "project_answer_background_color", rateValue: 4.5 }],
      project_chat_answer_text_color:     [{ pareKey: "project_answer_background_color", rateValue: 4.5 }],
      project_icon_copy_button_color:     [{ pareKey: "project_answer_background_color", rateValue: 3 }],
      project_question_background_color: [
        { pareKey: "project_question_answer_title_color", rateValue: 4.5 },
        { pareKey: "project_question_answer_subtitle_color", rateValue: 4.5 },
        { pareKey: "project_question_answer_textcolor", rateValue: 4.5 },
        { pareKey: "project_question_text_color", rateValue: 4.5 },
        { pareKey: "project_chat_question_title_color", rateValue: 4.5 },
        { pareKey: "project_chat_question_text_color", rateValue: 4.5 },
        { pareKey: "project_chat_question_subtitle_color", rateValue: 4.5 },
      ],
      project_chat_question_title_color:    [{ pareKey: "project_question_background_color", rateValue: 4.5 }],
      project_chat_question_text_color:     [{ pareKey: "project_question_background_color", rateValue: 4.5 }],
      project_chat_question_subtitle_color: [{ pareKey: "project_question_background_color", rateValue: 4.5 }],
      project_question_answer_title_color: [
        { pareKey: "project_question_background_color", rateValue: 4.5 },
        { pareKey: "project_answer_background_color", rateValue: 4.5 },
      ],
      project_question_answer_subtitle_color: [
        { pareKey: "project_question_background_color", rateValue: 4.5 },
        { pareKey: "project_answer_background_color", rateValue: 4.5 },
      ],
      project_question_answer_textcolor: [
        { pareKey: "project_question_background_color", rateValue: 4.5 },
        { pareKey: "project_answer_background_color", rateValue: 4.5 },
      ],
      project_question_text_color:        [{ pareKey: "project_question_background_color", rateValue: 4.5 }],
      project_icon_send_background_color: [{ pareKey: "project_icon_send_color", rateValue: 3 }],
      project_icon_send_color:            [{ pareKey: "project_icon_send_background_color", rateValue: 3 }],
      project_input_area_color:           [{ pareKey: "project_question_placeholder_color", rateValue: 4.5 }],
      project_question_placeholder_color: [{ pareKey: "project_input_area_color", rateValue: 4.5 }],
      project_header_color: [
        { pareKey: "project_header_text_color", rateValue: 4.5 },
        { pareKey: "project_icon_main_window_close_color", rateValue: 3 },
        { pareKey: "project_icon_resize_color", rateValue: 3 },
        { pareKey: "project_icon_font_size_change_color", rateValue: 3 },
        { pareKey: "project_icon_dark_mode_color", rateValue: 3 },
        { pareKey: "project_icon_light_mode_color", rateValue: 3 },
      ],
      project_header_text_color:              [{ pareKey: "project_header_color", rateValue: 4.5 }],
      project_icon_main_window_close_color:   [{ pareKey: "project_header_color", rateValue: 3 }],
      project_icon_resize_color:              [{ pareKey: "project_header_color", rateValue: 3 }],
      project_icon_font_size_change_color:    [{ pareKey: "project_header_color", rateValue: 3 }],
      project_icon_dark_mode_color:           [{ pareKey: "project_header_color", rateValue: 3 }],
      project_icon_light_mode_color:          [{ pareKey: "project_header_color", rateValue: 3 }],
      // These four depend on the currently selected project type, which can change after this
      // object is built (built once per field, at page load) - so they're resolved lazily via
      // getPairs() below, reading getCurrentProjectType() at check time, not baked in here.
      project_background_color: () => [
        ...(getCurrentProjectType() === "GRA" ? [] : [{ pareKey: "project_terms_conditions_link_color", rateValue: 4.5 }]),
        { pareKey: "project_icon_scroll_down_color", rateValue: 3 },
      ],
      project_terms_conditions_link_color: () => [
        ...(getCurrentProjectType() === "GRA" ? [] : [{ pareKey: "project_background_color", rateValue: 4.5 }]),
        getCurrentProjectType() === "GRA"
          ? { pareKey: "project_banner_background_color", rateValue: 4.5 }
          : { pareKey: "project_terms_conditions_background_color", rateValue: 4.5 },
      ],
      project_terms_conditions_background_color: () => getCurrentProjectType() === "GRA"
        ? []
        : [{ pareKey: "project_terms_conditions_link_color", rateValue: 4.5 }],
      project_banner_background_color: () => getCurrentProjectType() === "GRA"
        ? [{ pareKey: "project_terms_conditions_link_color", rateValue: 4.5 }]
        : [],
      project_icon_scroll_down_color:      [{ pareKey: "project_background_color", rateValue: 3 }],
      project_icon_chat_text_color: [
        { pareKey: "project_icon_chat_background_color_from", rateValue: 4.5 },
        { pareKey: "project_icon_chat_background_color_to", rateValue: 4.5 },
      ],
      project_icon_chat_background_color_from: [{ pareKey: "project_icon_chat_text_color", rateValue: 4.5 }],
      project_icon_chat_background_color_to:   [{ pareKey: "project_icon_chat_text_color", rateValue: 4.5 }],
    }

    const id = item.attr("id")
    if (!colorPars[id]) return

    const getPairs = fieldId => (typeof colorPars[fieldId] === "function" ? colorPars[fieldId]() : colorPars[fieldId])

    const createIcon = (itemId = id) => {
      const icon = document.createElement("span")
      icon.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="red" xmlns="http://www.w3.org/2000/svg"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>`
      icon.classList.add("contrast-warning-icon")
      icon.id = `${itemId}_contrast_icon`
      document.querySelector(`#${itemId}_input .label`)?.insertAdjacentElement("afterend", icon)
      icon.addEventListener("click", e => {
        e.stopPropagation()
        const msg = document.getElementById(`${itemId}_contrast_message`)
        if (msg) msg.style.display = "block"
      })
    }

    const createMessage = (contrast, visible = null, itemId = id) => {
      const message = document.createElement("div")
      message.classList.add("contrast-message")
      message.id = `${itemId}_contrast_message`
      message.style.display = visible ? "block" : "none"

      const title = document.createElement("h4")
      title.innerText = document.querySelector(`#${itemId}_input .label`)?.innerText || ""
      title.classList.add("contrast-message-title")
      message.appendChild(title)

      const body = document.createElement("div")
      contrast.forEach(pair => {
        const label = document.querySelector(`#${pair.pareKey}_input .label`)?.innerText || ""
        const block = document.createElement("div")
        block.id = `${pair.pareKey}_message_block`
        block.classList.add("contrast-message-block")
        const viaLabel = fieldId => document.querySelector(`#${fieldId}_input .label`)?.innerText || ""
        const ownViaNote = pair.ownVia
          ? `<br>Note: this field is empty — actual color used comes from <span class="contrast-pare-label">${viaLabel(pair.ownVia)}</span>`
          : ""
        const pairViaNote = pair.pairVia
          ? `<br>Note: pair field is empty — its actual color comes from <span class="contrast-pare-label">${viaLabel(pair.pairVia)}</span>`
          : ""
        const usedAsFallbackNote = pair.usedAsFallbackFor
          ? `<br>Note: this field's color is used here as a fallback for the empty <span class="contrast-pare-label">${viaLabel(pair.usedAsFallbackFor)}</span> field`
          : ""
        block.innerHTML = `Pair color field : <span class="contrast-pare-label">${label}</span><br>Current contrast ratio <span class="contrast-calculated-value" id="${pair.pareKey}_ratio_value">${pair.contrast.toFixed(2)}:1</span><br>The required minimum <span class="contrast-manual-value">${pair.rateValue}:1</span>${ownViaNote}${pairViaNote}${usedAsFallbackNote}<br><hr class="message-divider">`
        body.appendChild(block)
      })

      message.appendChild(body)
      document.getElementById(`${itemId}_input`)?.appendChild(message)
      message.addEventListener("click", () => { message.style.display = "none" })
    }

    const viewData = (visible = null, updatePairs = false) => {
      const failingPairs = []
      getPairs(id).forEach(pair => {
        if (updatePairs) $(`#${pair.pareKey}`).trigger("contrastUpdate")
        const own = resolveColor(id)
        const pairInfo = resolveColor(pair.pareKey)
        document.getElementById(`${id}_contrast_message`)?.remove()
        document.getElementById(`${id}_contrast_icon`)?.remove()
        if (own.color === null || pairInfo.color === null) return
        const contrast = getContrastRatio(own.color, pairInfo.color)
        if (Number(contrast) < Number(pair.rateValue)) {
          failingPairs.push({
            contrast,
            pareKey: pair.pareKey,
            rateValue: pair.rateValue,
            // When a side's own field is blank, the color actually compared came from a fallback
            // field instead — note which one, and flag that field too (below), since editing it
            // is what actually affects this contrast, not the blank field the user might expect.
            ownVia: own.sourceId !== id ? own.sourceId : null,
            pairVia: pairInfo.sourceId !== pair.pareKey ? pairInfo.sourceId : null,
          })
        }
      })
      if (failingPairs.length > 0) {
        createMessage(failingPairs, visible)
        createIcon()

        // Also flag whichever field actually supplied a fallback color for this comparison —
        // from that field's own perspective the "pair" is whichever side it stood in for.
        // Note: if two fields fall back to the same source field at once, the later one here
        // overwrites the earlier one's message on that source field (last one wins).
        failingPairs.forEach(pair => {
          if (pair.pairVia) {
            const propagated = { contrast: pair.contrast, rateValue: pair.rateValue, pareKey: id, usedAsFallbackFor: pair.pareKey }
            document.getElementById(`${pair.pairVia}_contrast_message`)?.remove()
            document.getElementById(`${pair.pairVia}_contrast_icon`)?.remove()
            createMessage([propagated], visible, pair.pairVia)
            createIcon(pair.pairVia)
          }
          if (pair.ownVia) {
            const propagated = { contrast: pair.contrast, rateValue: pair.rateValue, pareKey: pair.pareKey, usedAsFallbackFor: id }
            document.getElementById(`${pair.ownVia}_contrast_message`)?.remove()
            document.getElementById(`${pair.ownVia}_contrast_icon`)?.remove()
            createMessage([propagated], visible, pair.ownVia)
            createIcon(pair.ownVia)
          }
        })
      }
    }

    item.on("input", () => {
      viewData(true, true)
      ;(FALLBACK_DEPENDENTS[getCurrentProjectType()]?.[id] || []).forEach(depId => $(`#${depId}`).trigger("contrastUpdate"))
      const ownFallback = (EFFECTIVE_COLOR_FALLBACKS[getCurrentProjectType()] || {})[id]
      if (ownFallback && !HEX_COLOR_RE.test(ownFallback)) $(`#${ownFallback}`).trigger("contrastUpdate")
    })
    item.on("contrastUpdate", () => viewData(true))

    if (!contrastGlobalCloserBound) {
      contrastGlobalCloserBound = true
      document.addEventListener("click", e => {
        if (e.target.closest(".warning-icon") || e.target.closest(".minicolors-panel")) return
        document.querySelectorAll(".contrast-message").forEach(el => { el.style.display = "none" })
      })
    }

    viewData()
  }

  // ── Ace editor init ──────────────────────────────────────────────────────

  const initAceEditors = () => {
    for (const thisElement of document.querySelectorAll(".ace-editor-container")) {
      const thisEditor = ace.edit(thisElement)
      thisEditor.setOption("showPrintMargin", false)
      thisEditor.setOption("fontSize", "14px")
      thisEditor.setTheme("ace/theme/xcode")
      const mode = thisElement.getAttribute("data-options-mode")
      if (mode) thisEditor.session.setMode(`ace/mode/${mode}`)
      thisEditor.session.on("change", () => {
        const input = thisElement.parentElement.querySelector("input[type='hidden']")
        if (input) input.value = thisEditor.session.getValue()
      })
    }
  }

  window.addEventListener("load", initAceEditors)

  $(document).on("has_many_add:after", initAceEditors)

  $("select").on("change", function() {
    if ($(this).attr("id") === "" && $(this).data("id") !== "") {
      $(this).parent().find("input").attr("name", `q[${$(this).val()}]`)
    }
  })

  // ── Report scheduling ────────────────────────────────────────────────────

  const dateInput = document.getElementById("client_next_report_date")
  if (dateInput) {
    const pad = n => (n < 10 ? `0${n}` : `${n}`)

    const computeQuarter15th = today => {
      const firstMonth = Math.floor(today.getMonth() / 3) * 3 + 1
      return `${today.getFullYear()}-${pad(firstMonth)}-15`
    }

    const computeMonth15th = date => {
      let month = date.getMonth()
      let year = date.getFullYear()
      if (date.getDate() >= 15) {
        month++
        if (month > 11) { month = 0; year++ }
      }
      return `${year}-${pad(month + 1)}-15`
    }

    const nextReportDateLi = dateInput.closest("li")

    const toggleNextReportDate = () => {
      const checked = document.querySelector("input[name='client[report_scheduling]']:checked")
      if (nextReportDateLi && (checked?.value === "quarterly")) {
        $("#client_next_report_date").datepicker("option", "disabled", true)
        $("#client_next_report_date").prop('disabled', true);
        $("#client_next_report_date").parent("li").find("p.inline-hints").show()
      } else {
        $("#client_next_report_date").datepicker("option", "disabled", false)
        $("#client_next_report_date").prop('disabled', false);
        $("#client_next_report_date").parent("li").find("p.inline-hints").hide()
      }
    }

    document.querySelectorAll("input[name='client[report_scheduling]']").forEach(radio => {
      radio.addEventListener("change", () => {
        if (!radio.checked) { dateInput.value = ""; return }
        if (radio.value === "quarterly") { dateInput.value = computeQuarter15th(new Date()); toggleNextReportDate(); return }
        if (radio.value === "monthly") { dateInput.value = computeMonth15th(new Date()) ; toggleNextReportDate(); return }
        else dateInput.value = ""
        toggleNextReportDate()
      })
    })

    toggleNextReportDate()
  }

})

// ── Log comment submit confirmation ─────────────────────────────────────────
// Delegated on document — registered once at module load, survives page lifecycle.

document.addEventListener("submit", event => {
  const form = event.target
  if (!form?.classList?.contains("log_comment_answer")) return
  const internal = form.querySelector("input[type='checkbox'][name='log_comment_answer[internal]']")
  if (internal && !internal.checked) {
    if (!window.confirm("Are you sure you want to send this message to the client?")) {
      event.preventDefault()
    }
  }
})

// ── As Seen By AI reports (Client edit, Reports tab) ─────────────────────────
// Delegated on document — the status/history block is re-rendered on updates.

const AS_SEEN_BY_AI_FIELD = "client_as_seen_by_ai_attributes"

// Set once this page has seen a report in progress: its finished result (Completed/Failed)
// is then kept above the History table until the page is reloaded.
let asSeenByAIWatching = false

// The Generate button lives with the form actions, outside the re-rendered block,
// so it is (re-)enabled from the block's in-progress flag.
function rememberAsSeenByAIRunInProgress() {
  const inProgress = $("#as_seen_by_ai_reports .as-seen-by-ai-content").data("in-progress") === true
  if (inProgress) asSeenByAIWatching = true
  $("#as_seen_by_ai_generate").prop("disabled", inProgress)
}

// Re-fetches the status/history block, keeping the current history page.
function reloadAsSeenByAIReports(page) {
  const container = $("#as_seen_by_ai_reports")
  if (!container.length) return $.Deferred().resolve()

  const params = { page: page || container.find(".as-seen-by-ai-content").data("current-page") || 1 }
  if (asSeenByAIWatching) params.show_finished = 1

  return $.get(container.data("url"), params).done(html => {
    container.html(html)
    rememberAsSeenByAIRunInProgress()
  })
}

// Shows only the inputs relevant to the selected pages source / Content gap option.
function toggleAsSeenByAIFields() {
  const source = $(`input[name='client[as_seen_by_ai_attributes][pages_source]']:checked`).val()
  const sitemapBased = ["sitemap_sample", "all_pages"].includes(source)

  $(`#${AS_SEEN_BY_AI_FIELD}_sitemap_url_input, #${AS_SEEN_BY_AI_FIELD}_url_filter_input`).toggle(sitemapBased)
  $(`#${AS_SEEN_BY_AI_FIELD}_custom_urls_input`).toggle(source === "custom_urls")
  $(`#${AS_SEEN_BY_AI_FIELD}_content_gap_questions_input`).toggle($(`#${AS_SEEN_BY_AI_FIELD}_content_gap_enabled`).is(":checked"))
}

function showAsSeenByAIErrors(errors) {
  Object.entries(errors || {}).forEach(([field, messages]) => {
    $(`#${AS_SEEN_BY_AI_FIELD}_${field}_input`)
      .addClass("error")
      .append(`<p class="inline-errors as-seen-by-ai-error">${messages.map(m => $("<div>").text(m).html()).join("<br/>")}</p>`)
  })
}

$(document).on("change", "#as_seen_by_ai_settings input", toggleAsSeenByAIFields)

// Generate report is shown among the form actions only while the Reports tab is open.
$(document).on("tabscreate tabsactivate", "#active_admin_content .tabs", (event, ui) => {
  const panel = ui.panel || ui.newPanel
  $("#as_seen_by_ai_generate_action").toggle(panel.attr("id") === "reports")
})

$(document).on("click", "#as_seen_by_ai_generate", function() {
  const button = $(this)
  const message = $("#as_seen_by_ai_message")

  $(".as-seen-by-ai-error").remove()
  $("#as_seen_by_ai_settings li.error").removeClass("error")
  message.removeClass("error").text("")
  button.prop("disabled", true)

  $.post(button.data("url"), $("#as_seen_by_ai_settings :input").serialize())
    .done(data => {
      asSeenByAIWatching = true
      reloadAsSeenByAIReports(1).done(() => $("#as_seen_by_ai_message").text(data.message))
    })
    .fail(xhr => {
      const response = xhr.responseJSON || {}
      showAsSeenByAIErrors(response.errors)
      const base = (response.base || []).join(" ")
      message.addClass("error").text(base || "Please correct the report settings above.")
      button.prop("disabled", false)
    })
})

// Download YAML is a styled button: the file is sent as an attachment, so the page stays.
$(document).on("click", ".as-seen-by-ai-download", function() {
  window.location.href = $(this).data("url")
})

// The theme's actions-toggle binds row "⋮" menus once on page load; report history and
// MCP server rows are re-rendered by AJAX, so open/close their menus the same way via delegation.
const AJAX_ROW_MENUS = "#as_seen_by_ai_reports tbody .col-actions, #mcp_servers tbody .col-actions"

$(document).on("click", AJAX_ROW_MENUS, function(event) {
  event.stopPropagation()
  $(AJAX_ROW_MENUS).not(this).removeClass("active")
  // Picking a menu item closes the menu
  $(this).toggleClass("active", !$(event.target).closest(".table_actions a").length)
})

$(document).on("click", function() {
  $(AJAX_ROW_MENUS).removeClass("active")
})

$(document).on("click", "#as_seen_by_ai_reports [data-history-page]", function(event) {
  event.preventDefault()
  reloadAsSeenByAIReports($(this).data("history-page"))
})

function initAsSeenByAIReports() {
  toggleAsSeenByAIFields()
  rememberAsSeenByAIRunInProgress()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAsSeenByAIReports)
} else {
  initAsSeenByAIReports()
}

// ── MCP servers (OAuth apps) on the client MCP tab ───────────────────────────

function reloadMcpServers() {
  const container = $("#mcp_servers")
  return $.get(container.data("url")).done(html => container.html(html))
}

// Dialogs are built from the MCP tab templates and removed on close (the secret doesn't stay in the page).
// Their buttons are form actions, so they look like the client form's Update/Cancel.
function openMcpDialog(templateId, title, width) {
  const form = $($(`#${templateId}`).html())
  const dialog = form.dialog({
    modal: true,
    width,
    title,
    classes: { "ui-dialog": "mcp-dialog" },
    close: () => dialog.dialog("destroy").remove(),
  })
  form.on("click", ".mcp-dialog-cancel", event => {
    event.preventDefault()
    dialog.dialog("close")
  })
  return form
}

// The plaintext secret is returned only by create/regenerate, so this is the only place it is shown.
function showMcpSecret(credentials) {
  const form = openMcpDialog("mcp_secret_template", `${credentials.name}: credentials`, 760)
  form.find(".mcp-secret-uid").text(credentials.uid)
  form.find(".mcp-secret-value").text(credentials.secret)
  form.on("submit", event => {
    event.preventDefault()
    form.dialog("close")
  })
}

function mcpServerRequestFailed(xhr, message) {
  const status = xhr.status ? ` (${xhr.status})` : ""
  message.addClass("error").text(`Something went wrong${status}. Please try again.`)
}

// Create and Edit share one dialog; Create also shows the new secret.
function openMcpServerDialog({ title, url, method, submitText, values }) {
  const form = openMcpDialog("mcp_server_form_template", title, 640)
  const message = form.find(".mcp-server-message")
  form.find(".mcp-dialog-submit").val(submitText)
  form.find("#mcp_server_name").val(values.name || "")
  form.find("#mcp_server_redirect_uri").val(values.redirectUri || "")

  form.on("submit", event => {
    event.preventDefault()
    form.find("li.error").removeClass("error")
    form.find(".inline-errors").remove()
    message.removeClass("error").text("")

    $.ajax({ url, method, data: form.serialize(), dataType: "json" })
      .done(credentials => {
        form.dialog("close")
        reloadMcpServers()
        if (credentials && credentials.secret) showMcpSecret(credentials)
      })
      .fail(xhr => {
        const errors = (xhr.responseJSON || {}).errors
        if (!errors) return mcpServerRequestFailed(xhr, message)

        Object.entries(errors).forEach(([field, messages]) => {
          const input = form.find(`#mcp_server_${field}_input`)
          const text = messages.map(m => $("<div>").text(m).html()).join("<br/>")
          if (input.length) {
            input.addClass("error").append(`<p class="inline-errors">${text}</p>`)
          } else {
            message.addClass("error").html(text)
          }
        })
      })
  })
}

// The MCP tab is managed by its own dialogs, so the client form's Update/Cancel don't apply there.
$(document).on("tabscreate tabsactivate", "#active_admin_content .tabs", (event, ui) => {
  const panel = ui.panel || ui.newPanel
  $("body.admin_clients #main_content form > fieldset.actions").toggle(panel.attr("id") !== "mcp")
})

$(document).on("click", ".mcp-server-create", function() {
  openMcpServerDialog({
    title: "Create MCP server",
    url: $(this).data("url"),
    method: "POST",
    submitText: "Create",
    values: {},
  })
})

// Row menu (⋮) items: Regenerate secret, Edit, Delete
$(document).on("click", ".mcp-server-edit", function(event) {
  event.preventDefault()
  const link = $(this)
  openMcpServerDialog({
    title: `Edit ${link.data("name")}`,
    url: link.data("url"),
    method: "PATCH",
    submitText: "Save",
    values: { name: link.data("name"), redirectUri: link.data("redirect-uri") },
  })
})

$(document).on("click", ".mcp-server-regenerate", function(event) {
  event.preventDefault()
  const link = $(this)
  const question = `Regenerate the secret for ${link.data("name")}? The current secret will stop working ` +
    "and all issued tokens will be revoked. You will need to update it in ChatGPT."
  if (!window.confirm(question)) return

  $.ajax({ url: link.data("url"), method: "POST", dataType: "json" })
    .done(showMcpSecret)
    .fail(xhr => alert(`Could not regenerate the secret (${xhr.status}). Please try again.`))
})

$(document).on("click", ".mcp-server-destroy", function(event) {
  event.preventDefault()
  const link = $(this)
  const question = `Delete ${link.data("name")}? ChatGPT will lose access and all issued tokens will be revoked.`
  if (!window.confirm(question)) return

  $.ajax({ url: link.data("url"), method: "DELETE" })
    .done(reloadMcpServers)
    .fail(xhr => alert(`Could not delete the MCP server (${xhr.status}). Please try again.`))
})

// Shows "Copied" on the button for a few seconds after a successful copy
$(document).on("click", ".mcp-copy", function() {
  const button = $(this)
  // data-copy points to the Client ID or the secret within this dialog
  const text = button.closest("form").find(button.data("copy")).text()

  navigator.clipboard.writeText(text)
    .then(() => button.val("Copied").addClass("copied").removeClass("copy-failed"))
    .catch(() => button.val("Copy failed").addClass("copy-failed").removeClass("copied"))
    .finally(() => {
      clearTimeout(button.data("resetTimer"))
      button.data("resetTimer", setTimeout(() => button.val("Copy").removeClass("copied copy-failed"), 3000))
    })
})

// ── Sticky sidebar on admin project edit page ────────────────────────────────

;(function() {
  function initSidebarStickyToggle() {
    const body = document.body
    if (!body.classList.contains("admin_projects") || !body.classList.contains("edit")) return

    const sidebar = document.querySelector("#sidebar")
    const main = document.querySelector("#main_content")
    if (!sidebar || !main) return

    const topOffset = 24
    const sync = () => {
      if (main.getBoundingClientRect().top <= topOffset) {
        sidebar.classList.add("settings_viewer_sticky")
      } else {
        sidebar.classList.remove("settings_viewer_sticky")
      }
    }

    let raf = null
    const onScrollOrResize = () => {
      if (raf) return
      raf = requestAnimationFrame(() => { raf = null; sync() })
    }

    sync()
    window.addEventListener("scroll", onScrollOrResize, { passive: true })
    window.addEventListener("resize", onScrollOrResize)
    document.addEventListener("turbo:load", sync)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSidebarStickyToggle)
  } else {
    initSidebarStickyToggle()
  }
})()
